import { useCallback } from "react";
import { useNavigate } from "Navigation/useNavigate";
import type { MouseEvent } from "react";

export const useTableRowOnClickHandler = () => {
  const navigate = useNavigate();

  return useCallback(
    (url: string) => (e: MouseEvent<HTMLTableRowElement>) => {
      if (e.metaKey || e.ctrlKey || e.button === 1) {
        window.open(url, "_blank");
      } else {
        navigate(url);
      }
    },
    [navigate],
  );
};
